<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <nav aria-label="Progress" class="mb-6">
    <ol
      role="list"
      class="border border-gray-300 rounded-md divide-y divide-gray-300 md:flex md:divide-y-0"
    >
      <li
        v-for="(step, stepIndex) in steps"
        :key="step.name"
        class="relative md:flex-1 md:flex select-none"
        :class="{ 'cursor-pointer': stepIndex > 0 }"
        @click="goToStep(stepIndex)"
      >
        <div v-if="step.status === 'complete'" class="group flex items-center w-full">
          <span class="px-6 py-4 flex items-center text-sm font-medium">
            <span
              class="
                flex-shrink-0
                w-10
                h-10
                flex
                items-center
                justify-center
                bg-vice-teal-500
                rounded-full
              "
              :class="{ 'group-hover:bg-vice-teal-700': stepIndex > 0 }"
            >
              <CheckIcon class="w-6 h-6 text-white" aria-hidden="true" />
            </span>
            <div class="flex flex-col ml-4">
              <span class="text-sm font-medium text-gray-900">{{ step.name }}</span>
              <span class="text-sm font-medium text-gray-500">{{ step.description }}</span>
            </div>
          </span>
        </div>
        <div
          v-else-if="step.status === 'current'"
          class="px-6 py-4 flex items-center text-sm font-medium"
          aria-current="step"
        >
          <span
            class="
              flex-shrink-0
              w-10
              h-10
              flex
              items-center
              justify-center
              border-2 border-vice-teal-500
              rounded-full
            "
          >
            <span class="text-vice-teal-500">{{ step.id }}</span>
          </span>

          <div class="flex flex-col ml-4">
            <span class="text-sm font-medium text-vice-teal-500">{{ step.name }}</span>
            <span class="text-sm font-medium text-gray-500">{{ step.description }}</span>
          </div>
        </div>
        <div v-else class="group flex items-center">
          <span class="px-6 py-4 flex items-center text-sm font-medium">
            <span
              class="
                flex-shrink-0
                w-10
                h-10
                flex
                items-center
                justify-center
                border-2 border-gray-300
                rounded-full
                group-hover:border-gray-400
              "
            >
              <span class="text-gray-500 group-hover:text-gray-900">{{ step.id }}</span>
            </span>

            <div class="flex flex-col ml-4">
              <span class="text-sm font-medium text-gray-500 group-hover:text-gray-900">
                {{ step.name }}
              </span>
              <span class="text-sm font-medium text-gray-500">{{ step.description }}</span>
            </div>
          </span>
        </div>
        <template v-if="stepIndex !== steps.length - 1">
          <!-- Arrow separator for lg screens and up -->
          <div class="hidden md:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
            <svg
              class="h-full w-full text-gray-300"
              viewBox="0 0 22 80"
              fill="none"
              preserveAspectRatio="none"
            >
              <path
                d="M0 -2L20 40L0 82"
                vector-effect="non-scaling-stroke"
                stroke="currentcolor"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </template>
      </li>
    </ol>
  </nav>
</template>

<script>
import { CheckIcon } from '@heroicons/vue/solid';

export default {
  components: {
    CheckIcon,
  },
  emits: ['goToStep'],
  props: {
    steps: {
      type: Object,
    },
  },
  methods: {
    goToStep(stepIndex) {
      this.$emit('goToStep', stepIndex);
    },
  },
};
</script>
